import type { IconData } from '@stacksjs/iconify-core'

export const pentagon: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M17.562 21.56H6.437a1 1 0 0 1-.95-.692l-3.438-10.58a1 1 0 0 1 .363-1.117l9-6.54a1 1 0 0 1 1.176 0l9 6.54a1 1 0 0 1 .363 1.117l-3.437 10.58a1 1 0 0 1-.952.692\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default pentagon
